import React from 'react';

import { Spinner, Box } from '@chakra-ui/react';

const Loader: React.FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="auto"
      height="50vh"
      bg="white"
    >
      <Spinner size="xl" color="black" />
    </Box>
  );
};

export default Loader;
